import { OTPInput } from 'input-otp';
import { ComponentPropsWithoutRef, Ref } from 'react';

import { styles } from './InputOTP.styles';

export type InputOTPProps = {
  ref?: Ref<HTMLInputElement>;
} & ComponentPropsWithoutRef<typeof OTPInput>;

export function InputOTP({
  className,
  containerClassName,
  ref,
  ...props
}: InputOTPProps) {
  const slots = styles();
  return (
    <OTPInput
      ref={ref}
      containerClassName={slots.container({ className: containerClassName })}
      className={slots.base({ className })}
      {...props}
    />
  );
}

InputOTP.displayName = 'InputOTP';
